import { compose, lifecycle, withStateHandlers } from 'recompose'
import { STICKY_HEADER_ID } from 'constant'

export default compose(
  withStateHandlers(
    {
      isScrolledToEdge: false
    },
    {
      setScrolledToEdgeState: (state, { id: wrappedComponentID }) => () => {
        const wrappedComponent = window.document.getElementById(wrappedComponentID) // eslint-disable-line
        const stickyHeaderBlock = window.document.getElementById(STICKY_HEADER_ID) // eslint-disable-line

        if (wrappedComponent) {
          const { bottom } = wrappedComponent.getBoundingClientRect()
          const edge = stickyHeaderBlock ? stickyHeaderBlock.getBoundingClientRect().bottom : 0

          return {
            isScrolledToEdge: bottom < edge
          }
        }
      }
    }
  ),
  lifecycle({
    componentDidMount() {
      const { setScrolledToEdgeState } = this.props
      setScrolledToEdgeState()

      window.addEventListener('scroll', setScrolledToEdgeState)
    },
    componentWillUnmount() {
      const { setScrolledToEdgeState } = this.props

      window.removeEventListener('scroll', setScrolledToEdgeState)
    }
  })
)
